import { Component, OnInit, OnDestroy, ElementRef, Inject, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';
import { DirectionService } from '../../direction.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  PrinterMarginCM,
  getExpressPrinterMarginCM,
  getImageGapsCM,
  getPrintableArea,
} from 'src/app/utils/express-printer-margin';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
  host: {
    class: 'fill-screen-modal-image-preview'
  }
})
export class ImagePreviewComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;

  isLoading: boolean = false;
  isLoadingPreview: boolean = false;

  public printingService: string = '';
  public branch: string = '';
  public realBranch: any;
  public branches: any[] = [];
  public filteredBranches: { name: string, systems: string[] }[] = [];
  private printingServiceSubscription: Subscription;
  private branchSubscription: Subscription;
  printServicePapers: any[] = [];
  files: any[] = [];
  paperCodes: string[] = [];
  paperNames: string[] = [];
  currentFile: any;
  currentImage: any;
  currentImageIndex: number;
  isChosen: boolean = false;
  isPaperTypeLoading: boolean = false;
  isCurrentrotated: boolean = false;
  factor: number = 0;
  isCurrentBandW: boolean = false;
  selectedPaper: any;
  cropRatioValue: boolean = false;
  isFromTable: boolean = false;
  orderStatus: string = '';

  isAllFilesHavePaper: boolean = false;
  resizedInagePrintSettings: any;
  isFitRequired: boolean = false;
  scaleImageFactor: number = 1;
  serverAddress: string = '';
  expressServerAdress: string = 'https://img-express.eazix.io';

  // current image paper inputs
  currentPaperWidth: number;
  currentPaperHeight: number;
  // current image file inputs:
  currentImageWidth: number;
  currentImageHeight: number;
  // current image more inputs
  isCurrentCenter: boolean = false;
  currentPaperMargin: number = 0;

  // preview container inputs
  previewContainerWidth: number;
  previewContainerHeight: number;
  // preview paper inputs
  previewPaperWidth: number;
  previewPaperHeight: number;
  // preview file inputs:
  previewImageContainerWidth: number;
  previewImageContainerHeight: number;
  previewImageWidth: number;
  previewImageHeight: number;
  // preview more inputs
  previewPaperMargin: number;
  // [express] gaps (cm) between the preview image and the paper edges
  previewGapStartCM: number = 0;
  previewGapEndCM: number = 0;
  previewGapTopCM: number = 0;
  previewGapBottomCM: number = 0;
  /** Plotter: 5mm margins; Express: 3mm */
  get borderCM(): number {
    return this.printingService === 'plotter' ? 0.5 : 0.3;
  }

  constructor(
    private directionService: DirectionService,
    private dialogService: DialogService,
    private elRef: ElementRef,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.printingService = data.printingService;
    this.currentFile = data.currentFile;
    this.currentImage = data.currentImage;
    this.realBranch = data.realBranch;
    // console.log('realBranch', this.realBranch);
    this.selectedPaper = data.selectedPaper;
    if (this.printingService !== 'ph') {
      this.branch = data.realBranch.name;
      this.cropRatioValue = data.cropRatioValue;
      this.isFromTable = data.isFromTable;
    }
    this.orderStatus = data.orderStatus;
  }

  async ngOnInit() {
    this.isLoading = true;

    // Track if this is the first direction change (initial load)
    let isFirstDirectionChange = true;

    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      const previousIsRTL = this.isRTL;
      this.isRTL = direction === 'rtl';
      
      // If direction changed and component is already initialized, update preview
      if (!isFirstDirectionChange && previousIsRTL !== this.isRTL) {
        // Force change detection first to update HTML classes
        this.cdr.detectChanges();
        // Use setTimeout to ensure DOM is ready after direction change and classes are applied
        setTimeout(() => {
          if (this.printingService === 'plotter' && this.currentImage) {
            this.updatePreview();
          } else if (this.printingService === 'express' && this.currentFile) {
            this.updatePreviewExpress();
          }
          // Force change detection again after preview update
          this.cdr.detectChanges();
        }, 100);
      }
      isFirstDirectionChange = false;
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    if (this.printingService === 'plotter') {
      // console.log('plotter $$$');
      this.updatePreview();
      if (this.isFromTable) {
        this.serverAddress = this.realBranch.plotter.printers[0].serverAddress;
      } else {
        this.serverAddress = this.realBranch.serverAddress;
      }
    } else if (this.printingService === 'express') {
      // console.log('express $$$');
      this.updatePreviewExpress();
      this.serverAddress = this.expressServerAdress;
    }

    // console.log('## this.printingService', this.printingService);
    // console.log('## this.currentFile', this.currentFile);
    // console.log('## this.currentImage', this.currentImage);
    // console.log('## this.realBranch', this.realBranch);
    // console.log('## this.selectedPaper', this.selectedPaper);
    // console.log('## this.branch', this.branch);

    this.isLoading = false;
  }

  closeImagePreviewDialog() {
    this.dialogService.onCloseImagePreviewDialog();
  }

  // IMAGE PREVIEW
  // [plotter] IMAGE PREVIEW -------------------------------------
  updatePreview(): void {
    this.isLoadingPreview = true;

    // Get paper + image containers
    const previewPaperFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-paper-fullscreen');
    const previewImageContainerFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-image-container-fullscreen');

    // Reset dimensions
    previewPaperFS.style.width = `0px`;
    previewPaperFS.style.height = `0px`;
    // Reset img dimensions
    previewImageContainerFS.style.width = `0px`;
    previewImageContainerFS.style.height = `0px`;

    // Get container dimensions
    const previewContainerFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-container-fullscreen');

    // Get upper dim
    const upperDim1FS: HTMLElement = this.elRef.nativeElement.querySelector('#upperDim1-fullscreen');
    const upperDim2FS: HTMLElement = this.elRef.nativeElement.querySelector('#upperDim2-fullscreen');
    const upperDim3FS: HTMLElement = this.elRef.nativeElement.querySelector('#upperDim3-fullscreen');

    this.previewContainerWidth = previewContainerFS.offsetWidth;
    this.previewContainerHeight = previewContainerFS.offsetHeight;
    // Set paper width
    this.currentPaperWidth = this.selectedPaper.paperType.paperWidth / 1000;

    // margin?
    if (this.currentImage.printSettings.cmFromTop) {
      this.currentPaperMargin = 1;
    } else {
      this.currentPaperMargin = 0;
    }

    // Calculate if needs to rotate
    let BeforeRotationImageWidth = (this.currentImage.imageWidth / 300) * 2.54;
    let BeforeRotationImageHeight = (this.currentImage.imageHeight / 300) * 2.54;

    // --- FLIP FOR SAVEDD ORDERS WITH ROTATED FILES ---
    if ((!this.isFromTable && this.currentImage.printSettings?.isRotated && this.currentImage.origImageHeight && this.currentImage.origImageWidth) &&
      (
        ((this.currentImage.origImageHeight > this.currentImage.origImageWidth) && BeforeRotationImageHeight < BeforeRotationImageWidth) ||
        ((this.currentImage.origImageHeight < this.currentImage.origImageWidth) && BeforeRotationImageHeight > BeforeRotationImageWidth)
      )) {
      const d = BeforeRotationImageWidth;
      BeforeRotationImageWidth = BeforeRotationImageHeight;
      BeforeRotationImageHeight = d;
    }
    // // --- FLIP FOR SAVEDD ORDERS WITH ROTATED FILES ---

    if (BeforeRotationImageWidth >= this.currentPaperWidth &&
      BeforeRotationImageHeight >= this.currentPaperWidth) {
      return;
    }

    if (BeforeRotationImageWidth >= this.currentPaperWidth ||
      BeforeRotationImageHeight >= this.currentPaperWidth) {
      // 1 dim are too big
      if (BeforeRotationImageWidth > BeforeRotationImageHeight) {
        // width is bigger
        this.currentImageWidth = BeforeRotationImageHeight;
        this.currentImageHeight = BeforeRotationImageWidth;
        this.isCurrentrotated = true;
      } else {
        // height is bigger
        this.currentImageWidth = BeforeRotationImageWidth;
        this.currentImageHeight = BeforeRotationImageHeight;
        this.isCurrentrotated = false;
      }
    } else {
      // 2 dim are NOT too big
      if (BeforeRotationImageWidth > BeforeRotationImageHeight) {
        // width is bigger
        this.currentImageWidth = BeforeRotationImageWidth;
        this.currentImageHeight = BeforeRotationImageHeight;
        this.isCurrentrotated = false;
      } else {
        // height is bigger
        this.currentImageWidth = BeforeRotationImageHeight;
        this.currentImageHeight = BeforeRotationImageWidth;
        this.isCurrentrotated = true;
      }
    }

    this.currentPaperHeight = this.currentImageHeight + this.currentPaperMargin;

    // Calc dimantion of maximal preview size
    if (this.previewContainerHeight / this.previewContainerWidth > this.currentPaperHeight / this.currentPaperWidth) {
      // fit to width
      this.factor = this.previewContainerWidth / this.currentPaperWidth;
      this.previewPaperWidth = this.previewContainerWidth;
      this.previewPaperHeight = this.currentPaperHeight * this.factor;
      this.previewImageContainerWidth = this.currentImageWidth * this.factor;
      this.previewImageContainerHeight = this.currentImageHeight * this.factor;
    } else {
      // fit to height
      this.factor = this.previewContainerHeight / this.currentPaperHeight;
      this.previewPaperHeight = this.previewContainerHeight;
      this.previewPaperWidth = this.currentPaperWidth * this.factor;
      this.previewImageContainerHeight = this.currentImageHeight * this.factor;
      this.previewImageContainerWidth = this.currentImageWidth * this.factor;
    }

    if (!this.isCurrentrotated) {
      // not rotated
      this.previewImageWidth = this.previewImageContainerWidth;
      this.previewImageHeight = this.previewImageContainerHeight;
    } else {
      // rotated
      this.previewImageWidth = this.previewImageContainerHeight;
      this.previewImageHeight = this.previewImageContainerWidth;
    }

    // centered?
    if (this.currentImage.printSettings.centered) {
      this.isCurrentCenter = true;
    } else {
      this.isCurrentCenter = false;
    }
    // B and W?
    if (this.currentImage.printSettings.bw) {
      this.isCurrentBandW = true;
    } else {
      this.isCurrentBandW = false;
    }
    this.isLoadingPreview = false;

    // === Update borders ===
    const previewPaperOverlayFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-paper-overlay-fullscreen');
    const borderPX = this.borderCM * this.factor;
    previewPaperOverlayFS.style.border = `solid ${borderPX}px white`;
    // === Update borders ===

    // Update paper dimensions
    previewPaperFS.style.width = `${this.previewPaperWidth}px`;
    previewPaperFS.style.height = `${this.previewPaperHeight}px`;

    // Update img dimensions
    previewImageContainerFS.style.width = `${this.previewImageWidth}px`;
    previewImageContainerFS.style.height = `${this.previewImageHeight}px`;

    // Update dims preview dimensions
    if (!this.isCurrentCenter) {
      // if NOT centered
      upperDim1FS.style.width = `${this.previewPaperWidth - this.previewImageContainerWidth}px`;
      upperDim2FS.style.width = `${this.previewImageContainerWidth}px`;
      upperDim3FS.style.width = `0px`;
    } else {
      // if centered
      upperDim1FS.style.width = `${(this.previewPaperWidth - this.previewImageContainerWidth) / 2}px`;
      upperDim2FS.style.width = `${this.previewImageContainerWidth}px`;
      upperDim3FS.style.width = `${(this.previewPaperWidth - this.previewImageContainerWidth) / 2}px`;
    }
  }

  //[express] IMAGE PREVIEW -------------------------------------
  updatePreviewExpress(): void {
    this.isLoadingPreview = true;

    // Get paper + image containers
    const previewPaperFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-paper-fullscreen');
    const previewImageContainerFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-image-container-fullscreen');
    const previewPaperOverlayFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-paper-overlay-fullscreen');
    if (!previewPaperFS || !previewImageContainerFS) {
      return;
    }

    // Reset dimensions
    // Paper
    previewPaperFS.style.width = `0px`;
    previewPaperFS.style.height = `0px`;
    previewPaperOverlayFS.style.border = `unset`;
    // Image
    previewImageContainerFS.style.width = `0px`;
    previewImageContainerFS.style.height = `0px`;

    // Get container dimensions
    const previewContainerFS: HTMLElement = this.elRef.nativeElement.querySelector('#preview-container-fullscreen');

    // Get upper dim
    const upperDim1FS: HTMLElement = this.elRef.nativeElement.querySelector('#upperDim1-fullscreen');
    const upperDim2FS: HTMLElement = this.elRef.nativeElement.querySelector('#upperDim2-fullscreen');
    const upperDim3FS: HTMLElement = this.elRef.nativeElement.querySelector('#upperDim3-fullscreen');
    // Get sider dim
    const siderDim1FS: HTMLElement = this.elRef.nativeElement.querySelector('#siderDim1-fullscreen');
    const siderDim2FS: HTMLElement = this.elRef.nativeElement.querySelector('#siderDim2-fullscreen');
    const siderDim3FS: HTMLElement = this.elRef.nativeElement.querySelector('#siderDim3-fullscreen');

    this.previewContainerWidth = previewContainerFS.offsetWidth;
    this.previewContainerHeight = previewContainerFS.offsetHeight;

    // Get paper width
    if (this.currentFile && this.currentFile.printSettings && this.printServicePapers.find(paper => paper.paperName === this.currentFile.printSettings.paperType)) {
      this.selectedPaper = this.printServicePapers.find(paper => paper.paperName === this.currentFile.printSettings.paperType);
    }

    let isPics = false;
    if ((this.isFromTable && this.realBranch.express?.properties?.enable_crop) ||
      (!this.isFromTable && this.realBranch.isPicsPrinter)) {
      isPics = true;
    }

    const printerMargin = this.getExpressPrinterMarginCM();

    if (this.selectedPaper) {
      const paperCode = this.selectedPaper.serial_name;
      if (paperCode === 'A4') {
        this.currentPaperWidth = 21;
        this.currentPaperHeight = 29.7;
      } else if (paperCode === 'A3') {
        this.currentPaperWidth = 29.7;
        this.currentPaperHeight = 42;
      } else if (paperCode === 'A4160') {
        this.currentPaperWidth = 21;
        this.currentPaperHeight = 29.7;
      } else if (paperCode === 'A3160') {
        this.currentPaperWidth = 29.7;
        this.currentPaperHeight = 42;
      } else if (paperCode === 'A4Recycled') {
        this.currentPaperWidth = 21;
        this.currentPaperHeight = 29.7;
      } else if (paperCode === 'SM') {
        this.currentPaperWidth = 10.16;
        this.currentPaperHeight = 15.24;
      } else if (paperCode === 'MD') {
        this.currentPaperWidth = 12.7;
        this.currentPaperHeight = 17.78;
      } else if (paperCode === 'LG') {
        this.currentPaperWidth = 15.24;
        this.currentPaperHeight = 20.32;
      }

      // Calculate if needs to rotate 1
      let BeforeRotationImageWidth = (this.currentImage.imageWidth / this.currentImage.origImageDPI) * 2.54;
      let BeforeRotationImageHeight = (this.currentImage.imageHeight / this.currentImage.origImageDPI) * 2.54;

      // printer margins (if defined) reduce the area the image can occupy
      const printableArea = getPrintableArea(this.currentPaperWidth, this.currentPaperHeight, printerMargin);
      const printableWidth = printableArea.width;
      const printableHeight = printableArea.height;

      const biggerPaperDimm = Math.max(printableWidth, printableHeight);
      const smallerPaperDimm = Math.min(printableWidth, printableHeight);

      // check if original size is possible
      if ((biggerPaperDimm > BeforeRotationImageWidth && smallerPaperDimm > BeforeRotationImageHeight) ||
        (biggerPaperDimm > BeforeRotationImageHeight && smallerPaperDimm > BeforeRotationImageWidth)) {
        // original size is possible
        // console.log('original size is possible !!');
        this.isFitRequired = false;
      } else {
        // original size is NOT possible
        // console.log('original size is NOT possible !!');
        this.currentFile.printSettings.fit = true;
        this.isFitRequired = true;
      }

      if (this.currentFile?.printSettings?.fit) {
        // do fit
        // console.log('do fit !!');
        let factorIfNotRotater;
        let factorIfRotater;
        if (BeforeRotationImageWidth / printableWidth > BeforeRotationImageHeight / printableHeight) {
          factorIfNotRotater = BeforeRotationImageWidth / printableWidth;
          // console.log("factorIfNotRotater 01", factorIfNotRotater);
        } else {
          factorIfNotRotater = BeforeRotationImageHeight / printableHeight;
          // console.log("factorIfNotRotater 02", factorIfNotRotater);
        }
        if (BeforeRotationImageWidth / printableHeight > BeforeRotationImageHeight / printableWidth) {
          factorIfRotater = BeforeRotationImageWidth / printableHeight;
          // console.log("factorIfRotater 03", factorIfRotater);
        } else {
          factorIfRotater = BeforeRotationImageHeight / printableWidth;
          // console.log("factorIfRotater 04", factorIfRotater);
        }
        if (factorIfRotater < factorIfNotRotater) {
          // do rotate
          // console.log('do rotate !!');
          this.isCurrentrotated = true;
          const AfretRotationImageWidth = BeforeRotationImageHeight;
          const AfretRotationImageHeight = BeforeRotationImageWidth;
          if (printableWidth / AfretRotationImageWidth < printableHeight / AfretRotationImageHeight) {
            // fit to width
            // console.log('fit to width !!');
            this.scaleImageFactor = printableWidth / AfretRotationImageWidth;
            this.currentImageHeight = AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth = AfretRotationImageWidth * this.scaleImageFactor;
          } else {
            // fit to height
            // console.log('fit to height !!');
            this.scaleImageFactor = printableHeight / AfretRotationImageHeight;
            this.currentImageHeight = AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth = AfretRotationImageWidth * this.scaleImageFactor;
          }
        } else {
          // dont rotate
          // console.log('dont rotate !!');
          this.isCurrentrotated = false;
          const AfretRotationImageWidth = BeforeRotationImageWidth;
          const AfretRotationImageHeight = BeforeRotationImageHeight;
          if (printableWidth / AfretRotationImageWidth < printableHeight / AfretRotationImageHeight) {
            // fit to width
            // console.log('fit to width !!');
            this.scaleImageFactor = printableWidth / AfretRotationImageWidth;
            this.currentImageHeight = AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth = AfretRotationImageWidth * this.scaleImageFactor;
          } else {
            // fit to height
            // console.log('fit to height !!');
            this.scaleImageFactor = printableHeight / AfretRotationImageHeight;
            this.currentImageHeight = AfretRotationImageHeight * this.scaleImageFactor;
            this.currentImageWidth = AfretRotationImageWidth * this.scaleImageFactor;
          }
        }
      } else {
        // dont fit
        // console.log('dont fit !!');
        this.scaleImageFactor = 1;
        // fit in original size and orientation?
        if (printableWidth > BeforeRotationImageWidth && printableHeight > BeforeRotationImageHeight) {
          // do fit in original size and orientation
          // console.log('do fit in original size and orientation');
          this.isCurrentrotated = false;
          this.currentImageHeight = BeforeRotationImageHeight;
          this.currentImageWidth = BeforeRotationImageWidth;
        } else {
          // doesnt fit in original size and orientation
          // console.log('doesnt fit in original size and orientation');
          this.isCurrentrotated = true;
          this.currentImageHeight = BeforeRotationImageWidth;
          this.currentImageWidth = BeforeRotationImageHeight;
        }
      }

      // Calc dimantion of maximal preview size
      if (!this.isFromTable && !this.currentFile.printSettings?.cropRatio) {
        this.cropRatioValue = false;
      }

      if (isPics && this.cropRatioValue) {
        this.currentImageHeight = printableHeight;
        this.currentImageWidth = printableWidth;
      }

      // Calc dimantion of maximal preview size
      if (this.previewContainerHeight / this.previewContainerWidth > this.currentPaperHeight / this.currentPaperWidth) {
        // fit to width
        this.factor = this.previewContainerWidth / this.currentPaperWidth;
        this.previewPaperWidth = this.previewContainerWidth;
        this.previewPaperHeight = this.currentPaperHeight * this.factor;
        this.previewImageWidth = this.currentImageWidth * this.factor;
        this.previewImageHeight = this.currentImageHeight * this.factor;
      } else {
        // fit to height
        this.factor = this.previewContainerHeight / this.currentPaperHeight;
        this.previewPaperWidth = this.currentPaperWidth * this.factor;
        this.previewPaperHeight = this.previewContainerHeight;
        this.previewImageWidth = this.currentImageWidth * this.factor;
        this.previewImageHeight = this.currentImageHeight * this.factor;
      }

      // centered?
      this.isCurrentCenter = true;

      // B and W?
      if (this.currentImage?.printSettings?.bw) {
        this.isCurrentBandW = true;
      } else {
        this.isCurrentBandW = false;
      }

    }
    this.isLoadingPreview = false;

    previewImageContainerFS.style.left = '';
    previewImageContainerFS.style.top = '';

    // === Update borders ===
    if (printerMargin) {
      previewPaperOverlayFS.style.border = 'unset';
      previewPaperOverlayFS.style.borderLeft = `solid ${printerMargin.l * this.factor}px white`;
      previewPaperOverlayFS.style.borderRight = `solid ${printerMargin.r * this.factor}px white`;
      previewPaperOverlayFS.style.borderTop = `solid ${printerMargin.t * this.factor}px white`;
      previewPaperOverlayFS.style.borderBottom = `solid ${printerMargin.b * this.factor}px white`;
      previewImageContainerFS.style.borderTop = `unset`;
      previewImageContainerFS.style.borderBottom = `unset`;
      previewImageContainerFS.style.borderLeft = `unset`;
      previewImageContainerFS.style.borderRight = `unset`;
    } else {
      let borderPX = this.borderCM * this.factor;
      let borderPXTopBottom = 0;
      let borderPXLeftRight = 0;
      if (this.currentFile?.printSettings?.fit) {
        borderPXTopBottom = borderPX;
        borderPXLeftRight = borderPX;
        if (this.currentPaperHeight - this.currentImageHeight < this.borderCM * 2) {
          let newBorder = (this.borderCM * 2 - (this.currentPaperHeight - this.currentImageHeight)) / 2;
          borderPXTopBottom = newBorder * this.factor;
          if (borderPXTopBottom < 0) {
            borderPXTopBottom = 0;
          }
        } else {
          borderPXTopBottom = (this.currentPaperHeight / this.currentPaperWidth) * this.borderCM * this.factor;
        }
        if (this.currentPaperWidth - this.currentImageWidth < this.borderCM * 2) {
          let newBorder = (this.borderCM * 2 - (this.currentPaperWidth - this.currentImageWidth)) / 2;
          borderPXLeftRight = newBorder * this.factor;
          if (borderPXLeftRight < 0) {
            borderPXLeftRight = 0;
          }
        } else {
          borderPXLeftRight = (this.currentPaperHeight / this.currentPaperWidth) * this.borderCM * this.factor;
        }
      } else {
        borderPXTopBottom = 0;
        borderPXLeftRight = 0;
      }

      if (borderPX && borderPX > 0 && (!isPics && this.cropRatioValue)) {
        previewPaperOverlayFS.style.border = `solid ${borderPX}px white`;
      } else {
        previewPaperOverlayFS.style.border = `unset`;
      }

      if (!isPics) {
        previewImageContainerFS.style.borderTop = `solid ${borderPXTopBottom}px white`;
        previewImageContainerFS.style.borderBottom = `solid ${borderPXTopBottom}px white`;
        previewImageContainerFS.style.borderLeft = `solid ${borderPXLeftRight}px white`;
        previewImageContainerFS.style.borderRight = `solid ${borderPXLeftRight}px white`;
      } else {
        previewImageContainerFS.style.borderTop = `unset`;
        previewImageContainerFS.style.borderBottom = `unset`;
        previewImageContainerFS.style.borderLeft = `unset`;
        previewImageContainerFS.style.borderRight = `unset`;
      }
    }
    // // === Update borders ===

    // Update paper dimensions
    previewPaperFS.style.width = `${this.previewPaperWidth}px`;
    previewPaperFS.style.height = `${this.previewPaperHeight}px`;

    // Update img dimensions
    const containerWidthPX = this.isCurrentrotated ? this.previewImageHeight : this.previewImageWidth;
    const containerHeightPX = this.isCurrentrotated ? this.previewImageWidth : this.previewImageHeight;
    previewImageContainerFS.style.width = `${containerWidthPX}px`;
    previewImageContainerFS.style.height = `${containerHeightPX}px`;

    const gaps = getImageGapsCM(
      this.currentPaperWidth,
      this.currentPaperHeight,
      this.currentImageWidth,
      this.currentImageHeight,
      printerMargin
    );
    if (printerMargin) {
      // container is sized before rotation, so align its center with the image center
      const imageCenterXPX = (gaps.left + this.currentImageWidth / 2) * this.factor;
      const imageCenterYPX = (gaps.top + this.currentImageHeight / 2) * this.factor;
      previewImageContainerFS.style.left = `${imageCenterXPX - containerWidthPX / 2}px`;
      previewImageContainerFS.style.top = `${imageCenterYPX - containerHeightPX / 2}px`;
    }
    // upper dims are laid out in reading direction (RTL starts from the right)
    this.previewGapStartCM = this.isRTL ? gaps.right : gaps.left;
    this.previewGapEndCM = this.isRTL ? gaps.left : gaps.right;
    this.previewGapTopCM = gaps.top;
    this.previewGapBottomCM = gaps.bottom;

    upperDim1FS.style.width = `${this.previewGapStartCM * this.factor}px`;
    upperDim2FS.style.width = `${this.previewImageWidth}px`;
    upperDim3FS.style.width = `${this.previewGapEndCM * this.factor}px`;

    siderDim1FS.style.height = `${this.previewGapTopCM * this.factor}px`;
    siderDim2FS.style.height = `${this.previewImageHeight}px`;
    siderDim3FS.style.height = `${this.previewGapBottomCM * this.factor}px`;
  }

  /** [express] non-pics printer margins (cm), or null */
  getExpressPrinterMarginCM(): PrinterMarginCM | null {
    if (this.printingService !== 'express') {
      return null;
    }
    // from the printing table realBranch is a cluster, from orders it is the express printer itself
    const expressPrinter = this.isFromTable ? this.realBranch?.express : this.realBranch;
    return getExpressPrinterMarginCM(expressPrinter);
  }

  roundDown(num: number): number {
    return Math.round(num * 100) / 100;
  }

  getUserName() {
    return localStorage.getItem('userName');
  }

  // Get userName for file - use originalUserName if file was transferred
  getUserNameForFile(): string {
    if (this.currentFile && this.currentFile.originalUserName && this.currentFile.originalUserName.trim() !== '') {
      return this.currentFile.originalUserName;
    }
    return this.getUserName();
  }

  roundDownTowDecimal(num: number): number {
    return Math.round(num * 100) / 100;
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
  }

  isBw() {
    if (this.printingService === 'plotter') {
      return this.currentImage.printSettings.bw;
    } else if (this.printingService === 'express') {
      return this.currentFile.printSettings.bw;
    }
  }

  // [plotter]
  getImgPlotter() {
    if (this.isFromTable) {
      return this.serverAddress + '/uploads/' + this.getUserNameForFile() + '/' + this.currentImage.thumbnailPath.split('/').pop();
    } else {
      // === OLD & NEW ===
      const thumbnail = this.currentImage.thumbnailPath;
      const isNewThumbnail = thumbnail.startsWith("uploads") || thumbnail.startsWith("/home/ubuntu/IMG-Plotter");
      let newThumbnail = '';
      if (isNewThumbnail) {
        const serverAddress = this.realBranch?.serverAddress ? this.realBranch.serverAddress : '';
        if (thumbnail.startsWith("uploads")) {
          newThumbnail = serverAddress + "/" + thumbnail;
        } else {
          const shortThumbnail = thumbnail.replace('/home/ubuntu/IMG-Plotter', '');
          newThumbnail = serverAddress + shortThumbnail
        }
      } else {
        newThumbnail = thumbnail;
      }
      return newThumbnail;
    }
  }

  // [express]
  getImgExpress() {
    if (this.isFromTable) {
      return this.expressServerAdress + '/uploads/' + this.getUserNameForFile() + '/' + this.currentImage.thumbnailPath.split('/').pop();
    } else {
      // === OLD & NEW ===
      const thumbnail = this.currentImage.thumbnailPath
      const isNewThumbnail = thumbnail.startsWith("/home/ubuntu/IMG-Express");
      let newThumbnail = '';
      if (isNewThumbnail) {
        newThumbnail = thumbnail.replace('/home/ubuntu/IMG-Express', this.expressServerAdress);
      } else {
        if (this.orderStatus !== '' && (this.orderStatus === 'PENDING' ||
          this.orderStatus === 'QR' ||
          this.orderStatus === 'NOT_PAID')) {
          newThumbnail = 'https://' + this.realBranch?.serial_name + '.eazix.io/uploads/' + this.getUserNameForFile() + '/' + thumbnail.split('\\').pop();
        } else {
          newThumbnail = thumbnail;
        }
      }
      return newThumbnail;
    }
  }

  // ===============
}
